<script>
import { mixins, Line } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  name: "line-chart",
  extends: Line,
  mixins: [reactiveProp],
  props: ["options", "chartData"],
  mounted() {
    this.renderChart(this.chartData, this.options);
  }
};
</script>
